<p-toast position="top-right"></p-toast>

<p-sidebar [(visible)]="showBroadcastMessageDetailSideBar"
           [position]="'right'"
           [baseZIndex]="10000"
           (onHide)="cancel()"
           [style]="{width:'850px'}">
    <ng-template pTemplate="header">
        <div class="flex flex-row justify-content-between">

            <div class="flex flex-row">
                <div>
                    <div class="bm-header-title">{{broadcastMessage?.MessageTitle}}</div>
                </div>
            </div>

        </div>
    </ng-template>

    <div *ngIf="loading" style="text-align: center; padding: 30px;">
        <p-progressSpinner [style]="{width: '40px', height: '40px'}" styleClass="custom-spinner" strokeWidth="5"
                           fill="var(--surface-ground)" animationDuration="1s"></p-progressSpinner>
    </div>

    <div *ngIf="!loading" style="margin: 0 -14px;">
        <p-tabMenu [model]="menuItems" [activeItem]="menuItems[0]"></p-tabMenu>

        <div *ngIf="activeMenuTab === menuTab.Details">
            <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 135px)'}"
                           [styleClass]="'app-scrollpanel'">

                <div class="broadcast-message-block">
                    <div class="bm-info-text">Information about the message</div>

                    <div class="bm-info-title">Details</div>

                    <div class="flex flex-row flex-wrap">
                        <div class="bm-column">
                            <div class="bm-item">
                                <div class="bm-label">Channel Type</div>
                                <div class="bm-value mr-3">{{broadcastMessage?.BroadcastChannelTypeText}}</div>
                            </div>

                            <div class="bm-item">
                                <div class="bm-label">Broadcast Date and Time</div>
                                <div class="bm-value ml-3">{{broadcastMessage?.BroadcastStartDateTime}}</div>
                            </div>

                            <div class="bm-item">
                                <div class="bm-label">Receiver Type</div>
                                <div class="bm-value mr-3">{{broadcastMessage?.BroadcastReceiverTypeText}}</div>
                            </div>
                        </div>
                    </div>
                </div>

            </p-scrollPanel>

        </div>

        <div *ngIf="activeMenuTab === menuTab.Message">
            <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 135px)'}"
                           [styleClass]="'app-scrollpanel'">

                <div class="broadcast-message-block">
                    <div class="bm-info-text">Information about the message</div>

                    <div class="bm-info-title">Message</div>

                    <div>
                        <div class="bm-label">Title</div>
                        <div class="bm-value">{{broadcastMessage?.MessageTitle}}</div>
                    </div>

                    <div>
                        <div class="bm-label">Subtitle</div>
                        <div class="bm-value">{{broadcastMessage?.MessageSubTitle}}</div>
                    </div>

                    <div>
                        <div class="bm-label">Image</div>
                        <div>
                            <img class="bm-img" src="{{broadcastMessage?.MessageImageUrl}}"/>
                        </div>
                    </div>

                    <div>
                        <div class="bm-label">Body</div>
                        <div class="bm-value h-12rem">{{broadcastMessage?.MessageText}}</div>
                    </div>
                </div>

            </p-scrollPanel>

        </div>


    </div>

</p-sidebar>
